import { computed, ref } from 'vue'

const notificationQueue = ref([])
let notificationId = 0

const levelMap = {
  error: { color: 'error', icon: 'mdi-alert-circle' },
  info: { color: 'info', icon: 'mdi-information' },
  success: { color: 'success', icon: 'mdi-check-circle' },
  warning: { color: 'warning', icon: 'mdi-alert' },
}

const fallbackLevel = levelMap.info
const notificationMessage = computed(
  () => notificationQueue.value[0]?.text || ''
)

export function useNotificationState() {
  const notify = (input, level = 'info', timeout = 8000) => {
    const payload = toNotificationPayload(input, level, timeout)
    if (!payload?.text) return

    const mapped = levelMap[payload.level] || fallbackLevel

    notificationQueue.value = [
      ...notificationQueue.value,
      {
        color: payload.color || mapped.color,
        icon: payload.icon || mapped.icon,
        id: ++notificationId,
        text: payload.text,
        timeout: payload.timeout,
        title: payload.title || '',
      },
    ]
  }

  const clearNotifications = () => {
    notificationQueue.value = []
  }

  return {
    clearNotifications,
    notificationMessage,
    notificationQueue,
    notify,
  }
}

function toNotificationPayload(input, level, timeout) {
  if (typeof input === 'string') {
    return {
      level,
      text: input,
      timeout,
    }
  }

  if (!input || typeof input !== 'object') return null

  return {
    color: input.color,
    icon: input.icon,
    level: input.level || input.type || level,
    text: input.text || input.message || '',
    timeout: input.timeout ?? timeout,
    title: input.title || '',
  }
}
